<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="delwlsq-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            物料申请
            <el-button type="primary" class="add-btn" icon="el-icon-plus" @click="editApply('0')">添加申请</el-button>
            <div class="search-mode">
              <input v-model="search" type="text" class="search-input" placeholder="关键字搜索" @keyup.enter="Search">
              <el-button class="search-btn" icon="el-icon-search" @click="Search" />
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===9?'active':''" @click="change(9)">全部</li>
                  <li :class="type===0?'active':''" @click="change(0)">待结清</li>
                  <li :class="type===1?'active':''" @click="change(1)">待发货</li>
                  <li :class="type===2?'active':''" @click="change(2)">已完成</li>
                </ul>
              </el-col>
              <el-col v-loading="loading" :span="19">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  style="width: 100%"
                >
                  <el-table-column
                    label="申请单号"
                    width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="danger">待结清</el-tag>
                      <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已完成</el-tag>
                      <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="warning">待发货</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{ scope.row.apply_order }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-user"></i> {{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-time"></i> {{ scope.row.apply_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">申请人：</span>{{ scope.row.userName }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">备注：</span>
                      <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                      <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="费用金额"
                    fixed="right"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">总价：</span>
                      <span style="font-weight: 500;color:#409EFF;">{{ scope.row.addprice }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已收款"
                    fixed="right"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">已收：</span>
                      <span v-if="scope.row.paidfor<scope.row.addprice" style="color:#f56c6c;font-weight: 500;">{{ scope.row.paidfor }}</span>
                      <span v-if="scope.row.paidfor>=scope.row.addprice" style="color:#409EFF;font-weight: 500;">{{ scope.row.paidfor }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="200"
                    fixed="right"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-dropdown v-if="scope.row.mark!==2&&(scope.row.opertime===null||scope.row.opertime===''||scope.row.opertime===undefined)" size="mini" split-button icon="el-icon-edit" @click="editApply(scope.row.apply_id)">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="color:#F56C6C" @click.native="delApply(scope.row.apply_id)"><i class="el-icon-delete"></i> 删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button v-if="(scope.row.mark!==2&&scope.row.opertime!==null&&scope.row.opertime!==''&&scope.row.opertime!==undefined)||scope.row.mark===2" icon="el-icon-search" size="mini" @click="view(scope.row.apply_id)">查看详情</el-button>
                      <el-button v-if="scope.row.addprice>0" icon="el-icon-document" style="margin-left: 0" size="mini" @click="getCollectRecord(scope.row)">收款</el-button>
                      <el-button v-if="scope.row.addprice<=0" icon="el-icon-document" style="margin-left: 0" :disabled="true" size="mini">收款</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="900px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules" label-width="70px" size="small">
        <el-form-item v-if="editForm.maid==='0'" label="经销商" prop="delinfo">
          <el-select v-model="editForm.delinfo" :disabled="true" style="width:400px">
            <el-option
              v-for="item in dealerInfo"
              :label="item.allname"
              :value="item.delid+','+item.isnewbus"
            >
              <span style="float: left"><el-tag v-if="item.isnewbus===1" :disable-transitions="true" style="margin-right: 10px" size="mini">新商</el-tag>{{ item.allname }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }} {{ item.city }} {{ item.county }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="editForm.maid!=='0'" style="margin-bottom: 10px">
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ editForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">经销商：</span>
          <span>{{ editForm.delname }}</span>
        </div>
        <div v-if="editForm.isnewbus===1" style="padding-left: 10px;font-size: 13px;color:#99a9bf;margin-bottom: 10px">
          <i class="el-icon-info"></i> 申请提示：您是新商，可免费选取标配物料，超出标配数量则追加相应价格
        </div>
        <el-table
          ref="multipleTable"
          :data="materialList"
          size="small"
          border
          tooltip-effect="dark"
          show-summary
          :summary-method="getSummaries"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="index"
            align="center"
            width="45"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="标配数量"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_standard===1">{{ scope.row.standard }}</span>
              <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="price"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            type="selection"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="155"
          >
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.counts" :disabled="scope.row.ischeck===false" :min="0" :max="99999999999" size="mini"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="价格/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.addprice>0" style="font-weight: 500;color:#409EFF">{{ scope.row.addprice }}</span>
              <span v-if="scope.row.addprice<=0" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="增加备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="物料申请单详情"
      :visible.sync="viewVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="viewForm" v-loading="viewLoading" :model="viewForm" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ viewForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">经销商：</span>
          <span>{{ viewForm.delinfo }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ viewForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="viewForm.remark!==null&&viewForm.remark!==''&&viewForm.remark!==undefined">{{ viewForm.remark }}</span>
          <span v-if="viewForm.remark===null||viewForm.remark===''||viewForm.remark===undefined">N/A</span>
        </div>
        <div v-if="viewForm.isnewbus===1" style="font-size: 13px;color:#f56c6c;margin-bottom: 10px">
          <i class="el-icon-info"></i> 申请提示：此次为新商申请，选取标配物料免费，超出标配数量则追加相应价格
        </div>
        <el-table
          ref="multipleTable"
          :data="ViewMaterialList"
          size="small"
          border
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="标配数量"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_standard===1">{{ scope.row.standard }}</span>
              <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="price"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            label="价格/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.addprice>0" style="font-weight: 500;color:#409EFF">{{ scope.row.addprice }}</span>
              <span v-if="scope.row.addprice<=0" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <span style="color:#99a9bf;">处理人：</span>
          <span>{{ viewForm.operName }}</span>
          <span style="color:#99a9bf;margin-left:30px">处理时间：</span>
          <span>{{ viewForm.opertime }}</span>
        </div>
        <div style="margin:10px 0">
          <el-image
            v-for="iurl in imgSrcList"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="iurl"
            :preview-src-list="imgSrcList"
          >
          </el-image>
        </div>
        <!--        <el-form-item style="text-align: right;">-->
        <!--          <el-button @click="viewVisible=false">关闭</el-button>-->
        <!--        </el-form-item>-->
      </el-form>
    </el-dialog>
    <el-dialog
      :title="collectRecordTitle"
      :visible.sync="collectRecordDialog"
      width="900px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div style="height:40px">
        <span style="color:#99a9bf;">经销商：</span>
        <span>{{ editCollectForm.delname }}</span>
        <span style="color:#99a9bf;margin-left:30px">总价：</span>
        <span style="font-weight: 500;color:#409EFF">{{ editCollectForm.totalprice }}</span>
        <el-button size="small" icon="el-icon-plus" type="primary" style="float: right;" @click="addCollect">添加收款</el-button>
      </div>
      <el-table
        v-loading="collectRecordLoading"
        :data="collectRecord"
        height="400"
        style="width: 100%;border:1px solid #EBEEF5;"
        size="small"
      >
        <el-table-column
          prop="ranum"
          label="收款流水号"
          align="center"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="paycontent"
          label="收款内容"
          align="center"
          width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="receipttime"
          label="收款日期"
          align="center"
          width="110"
          show-overflow-tooltip
        >
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="type"-->
        <!--          label="收款类型"-->
        <!--          align="center"-->
        <!--          width="100">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span v-if="scope.row.type===0">账户收款</span>-->
        <!--            <span v-if="scope.row.type===1">账户扣款</span>-->
        <!--            <span v-if="scope.row.type===2">微信</span>-->
        <!--            <span v-if="scope.row.type===3">售后赔款</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          prop="nature"
          label="收款性质"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="收款金额"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="card"
          align="center"
          label="卡号"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="operName"
          label="操作人"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="审核状态"
          fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">已拒绝</el-tag>
            <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已审核</el-tag>
            <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">审核中</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          fixed="right"
          width="120"
        >
          <template slot-scope="scope">
            <el-dropdown v-if="scope.row.mark!==2" size="mini" split-button icon="el-icon-edit" @click="editCollect(scope.row)">
              <i class="el-icon-edit"></i> 编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="color:#F56C6C" @click.native="delCollect(scope.row)"><i class="el-icon-delete"></i> 删除收款</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="scope.row.mark===2" icon="el-icon-search" size="mini" @click="viewCollect(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="editCollectTitle"
      :visible.sync="editCollectVisible"
      width="570px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editCollectForm" v-loading="collectInfoLoading" :model="editCollectForm" :rules="editCollectRules" label-position="right" label-width="90px" size="small">
        <!--        <el-form-item label="收款类型" prop="type">-->
        <!--          <el-radio v-model="editCollectForm.type" :label="99">收款申请</el-radio>-->
        <!--          <el-radio v-model="editCollectForm.type" :label="0">账户扣款</el-radio>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="账户余额" v-if="editCollectForm.type===0">-->
        <!--          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ editCollectForm.accamount }}</span>元-->
        <!--          <span style="color:#99a9bf">（{{ editCollectForm.accname }}）</span>-->
        <!--        </el-form-item>-->
        <div v-if="editCollectForm.type===99">
          <div style="font-size: 12px;color:#f56c6c;margin-bottom: 18px;padding-left: 20px">
            <i class="el-icon-info"></i> 收款提示：此收款申请财务审核通过后将自动加入此物料申请收款单中
          </div>
          <el-form-item v-if="editCollectForm.audittime!==null&&editCollectForm.audittime!==''" label="审核信息">
            <el-card class="box-card">
              <div style="color:#606266;font-size: 13px;">
                <span><span style="color:#99a9bf">审核时间：</span>{{ editCollectForm.audittime }}</span>
                <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ editCollectForm.auditname }}</span>
              </div>
              <div v-if="editCollectForm.rson!=''&&editCollectForm.rson!=null" style="color:#606266;font-size: 13px;">
                <span style="color:#99a9bf">拒绝原因：</span>{{ editCollectForm.rson }}
              </div>
            </el-card>
          </el-form-item>
          <el-form-item label="收款内容" prop="paycontent">
            <el-select v-model="editCollectForm.paycontent">
              <el-option label="全款" value="全款"></el-option>
              <el-option label="一次款" value="一次款"></el-option>
              <el-option label="二次款" value="二次款"></el-option>
              <el-option label="三次款" value="三次款"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款账户" prop="aid">
            <el-select v-model="editCollectForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
              <el-option-group
                v-for="gitem in groupList"
                v-if="gitem.nature===0"
                :key="gitem.groupid"
                :label="gitem.account_name"
              >
                <el-option
                  v-for="item in accountsList"
                  v-if="item.groupid===gitem.groupid"
                  :key="item.aid"
                  :label="item.name+'（'+item.card+'）'"
                  :value="item.aid"
                >
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="收款性质" prop="nature">
            <el-select v-model="editCollectForm.nature">
              <el-option
                v-for="item in receiptNatureList"
                :key="item.rntid"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款日期" prop="receipttime">
            <el-date-picker
              v-model="editCollectForm.receipttime"
              type="date"
              style="width:240px"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收款金额" prop="money">
            <el-input v-model="editCollectForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="卡号" prop="card">
            <el-input v-model="editCollectForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="打款凭证" prop="imgids">
            <MultiImg :key="imgLoad" v-model="editCollectForm.imgids" :limit="9" :size="'sm'" :old="editimgList" />
          </el-form-item>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editCollectForm.remark" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editCollectloading" @click="subCollectEdit('editCollectForm')">立即提交</el-button>
          <el-button @click="editCollectVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="收款详情"
      :visible.sync="viewCollectVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewCollectLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewCollectData.operName }}</td>
          <th>申请时间</th>
          <td>{{ viewCollectData.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ viewCollectData.ranum }}</td>
          <th>卡号</th>
          <td>{{ viewCollectData.card }}</td>
        </tr>
        <tr>
          <th>收款账户</th>
          <td colspan="3">{{ viewCollectData.accountname }}（{{ viewCollectData.accname }}，{{ viewCollectData.acccard }}）</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ viewCollectData.receipttime }}</td>
          <th>收款性质</th>
          <td>{{ viewCollectData.nature }}</td>
        </tr>
        <tr>
          <th>收款内容</th>
          <td>{{ viewCollectData.paycontent }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewCollectData.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in viewCollectImg"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="viewCollectImg"
            >
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ viewCollectData.remark }}</td>
        </tr>
        <tr v-if="viewCollectData.mark===2">
          <th>审核人</th>
          <td>{{ viewCollectData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ viewCollectData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewCollectVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpDealerList, getReceiptNature } from '@/api/erp'
import { getMaterialApplyDetail, addOrEditMaterialApply, getMaterialApplyListOfDealer, deleteMaterialApply, materialsCollectRecord, editMaterialCollectRecord, delMaterialCollectRecord, getCollectRecordMaterialsByCrmid } from '@/api/work'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'Delwlsq',
  components: {
    MultiImg
  },
  data() {
    return {
      viewVisible: false,
      viewLoading: false,
      ViewMaterialList: [],
      imgSrcList: [],
      viewdata: [],
      fullscreenLoading: false,
      editTitle: '添加物料申请',
      dealerInfo: [],
      groupList: [],
      receiptNatureList: [],
      accountsList: [],
      imgLoad: '',
      editimgList: [],
      search: '',
      type: 9,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      audittime: '',
      auditname: '',
      auditrson: '',
      infoLoading: false,
      materialList: [],
      multipleSelection: [],
      editForm: {
        maid: '',
        delinfo: '',
        delid: '',
        isnewbus: 0,
        remark: '',
        manum: '',
        delname: ''
      },
      editRules: {
        delinfo: [{ required: true, message: '请选择经销商', trigger: 'change' }]
      },
      editloading: false,
      viewForm: {
        maid: '',
        manum: '',
        addprice: 0,
        delinfo: '',
        isnewbus: 0,
        remark: '',
        operName: '',
        opertime: '',
        imgids: []
      },
      collectRecordDialog: false,
      collectRecordLoading: false,
      collectRecord: [],
      collectRecordTitle: '',
      editCollectVisible: false,
      collectInfoLoading: false,
      editCollectForm: {
        crmid: 0,
        maid: '',
        delid: '',
        delname: '',
        totalprice: 0,
        type: 99,
        accid: null,
        money: null,
        remark: '',
        accamount: 0,
        accname: '',
        receipttime: '',
        card: '',
        aid: null,
        nature: '',
        imgids: [],
        paycontent: '',
        audittime: '',
        auditname: '',
        rson: ''
      },
      editCollectRules: {
        paycontent: [{ required: true, message: '请选择收款内容', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        nature: [{ required: true, message: '请选择收款性质', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择收款日期', trigger: 'change' }],
        type: [{ required: true, message: '请选择收款类型', trigger: 'change' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        money: [{ required: true, message: '请输入收款金额', trigger: 'blur' }]
      },
      editCollectloading: false,
      editCollectTitle: '',
      viewCollectVisible: false,
      viewCollectLoading: false,
      viewCollectData: [],
      viewCollectImg: []
    }
  },
  computed: {
    user: getUser
  },
  watch: {
    'editForm.delinfo': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        const arr = newVal.split(',')
        this.editForm.delid = arr[0]
        this.editForm.isnewbus = parseInt(arr[1])
      } else {
        this.editForm.delid = ''
        this.editForm.isnewbus = 0
      }
      this.refAmount()
    },
    'materialList': {
      handler(newValue, oldValue) {
        this.refAmount()
      },
      deep: true
    }
  },
  created() {
    this.getData()
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search !== null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        status: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid
      }
      getMaterialApplyListOfDealer(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editApply(id) {
      this.dealerInfo = []
      this.materialList = []
      this.editForm.maid = id
      this.editForm.remark = ''
      getErpDealerList({ delid: this.user.delid, iswl: 1, maid: id }).then(response => {
        this.dealerInfo = response.data
        for (const d of this.dealerInfo) {
          this.editForm.delinfo = d.delid + ',' + d.isnewbus
          break
        }
        if (id === '0') {
          this.editTitle = '添加物料申请'
          this.editForm.manum = ''
          this.editForm.delname = ''
        } else {
          this.editTitle = '编辑物料申请'
        }
        this.infoLoading = true
        getMaterialApplyDetail({ applyid: this.editForm.maid }).then(response => {
          if (this.dealerInfo.length !== 0) {
            const _materialList = []
            for (const material of response.data.materialList) {
              if (this.dealerInfo[0].groupid === 1 || this.dealerInfo[0].groupid === 2) {
                if (material.brandName === '乔金斯' || material.brandName === '云庭御邑') {
                  _materialList.push(material)
                }
              } else {
                if (material.brandName === '首造') {
                  _materialList.push(material)
                }
              }
            }
            this.materialList = _materialList.filter(r => r.is_standard === 1)
          }
          if (id !== '0') {
            this.editForm.remark = response.data.materialsApply.remark
            this.editForm.manum = response.data.materialsApply.manum
            this.editForm.delname = response.data.materialsApply.delname
            for (const d of this.dealerInfo) {
              if (d.delid === response.data.materialsApply.delid) {
                this.editForm.delinfo = d.delid + ',' + d.isnewbus
                break
              }
            }
            const _this = this
            setTimeout(function() {
              _this.editForm.isnewbus = response.data.materialsApply.isnewbus
              const old = []
              for (let i = 0; i < _this.materialList.length; i++) {
                if (_this.materialList[i].ischeck) {
                  old.push(i)
                }
              }
              for (const i of old) {
                _this.$refs.multipleTable.toggleRowSelection(_this.materialList[i])
              }
            }, 100)
          }
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }).catch(() => {
        this.dealerInfo = []
        this.editForm.delinfo = ''
      })
      this.editVisible = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      for (const m of this.materialList) {
        m.ischeck = false
        for (const c of this.multipleSelection) {
          if (m.material_id === c.material_id) {
            m.ischeck = true
            if (this.editForm.isnewbus === 1 && m.is_standard === 1) {
              if (m.counts === 0) {
                m.counts = m.standard
              }
            }
            break
          }
        }
      }
    },
    refAmount() {
      let pricetotal = 0
      for (const m of this.materialList) {
        if (m.ischeck) {
          if (this.editForm.isnewbus === 1) {
            let count = m.counts
            if (m.is_standard === 1) {
              count = count - m.standard
              if (count < 0) {
                count = 0
              }
            }
            m.addprice = (m.price * count).toFixed(2)
          } else {
            m.addprice = (m.price * m.counts).toFixed(2)
          }
          pricetotal = pricetotal + parseFloat(m.addprice)
        } else {
          m.addprice = 0
        }
      }
      const totalspan = document.getElementById('pricetotal')
      if (totalspan !== null && totalspan !== undefined) {
        totalspan.innerHTML = pricetotal.toFixed(2)
      }
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 8) {
          sums[index] = '合计费用'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (values.every(value => isNaN(value))) {
          this.$nextTick(() => {
            const a = document.querySelector('.el-table__footer').querySelectorAll('td')[9].querySelector('.cell')
            const html = '<span style="color:#409EFF;font-weight: 500;font-size: 14px" id="pricetotal">0</span>'
            a.innerHTML = html
          })
        }
      })
      return sums
    },
    delApply(id) {
      this.$confirm('删除此物料申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteMaterialApply({ applyId: id }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            let details = ''
            let pricetotal = 0
            for (const m of this.materialList) {
              if (m.ischeck && m.counts > 0) {
                pricetotal = pricetotal + parseFloat(m.addprice)
                details += m.material_id + ':' + m.counts + ','
              }
            }
            if (details.length <= 0) {
              this.$message.error('至少勾选一个物料并且数量不为0')
              return false
            }
            details = '{' + details.substring(0, details.length - 1) + '}'
            this.editloading = true
            const data = {
              userid: this.user.userid,
              usertype: 0,
              did: this.editForm.delid,
              applyid: this.editForm.maid,
              remark: this.editForm.remark,
              materialStr: details,
              price: pricetotal.toFixed(2),
              isnewbus: this.editForm.isnewbus
            }
            addOrEditMaterialApply(data).then(response => {
              this.$message({
                message: '物料申请提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    view(id) {
      this.imgSrcList = []
      this.viewForm.isnewbus = 0
      this.ViewMaterialList = []
      this.viewForm.imgids = []
      this.viewForm.maid = id
      this.viewForm.remark = ''
      this.viewLoading = true
      getMaterialApplyDetail({ applyid: id }).then(response => {
        const datalist = []
        for (const m of response.data.materialList) {
          if (m.ischeck) {
            if (response.data.materialsApply.isnewbus === 1) {
              let count = m.counts
              if (m.is_standard === 1) {
                count = count - m.standard
                if (count < 0) {
                  count = 0
                }
              }
              m.addprice = (m.price * count).toFixed(2)
            } else {
              m.addprice = (m.price * m.counts).toFixed(2)
            }
            datalist.push(m)
          }
        }
        this.ViewMaterialList = datalist
        this.viewForm.remark = response.data.materialsApply.remark
        this.viewForm.isnewbus = response.data.materialsApply.isnewbus
        this.viewForm.manum = response.data.materialsApply.manum
        this.viewForm.addprice = response.data.materialsApply.addprice
        this.viewForm.delinfo = response.data.materialsApply.delname
        this.viewForm.operName = response.data.materialsApply.operName
        this.viewForm.opertime = response.data.materialsApply.opertime
        const imgs = []
        for (const c of response.data.materialsApply.imgList) {
          imgs.push(c.imgUrl)
        }
        this.imgSrcList = imgs
        this.viewLoading = false
      }).catch(() => {
        this.viewLoading = false
      })
      this.viewVisible = true
    },
    getCollectRecord(row) {
      this.collectRecordTitle = '物料申请单 ' + row.apply_order + ' 收款详细'
      this.editCollectForm.delid = row.dealar_id
      this.editCollectForm.delname = row.all_name
      this.editCollectForm.totalprice = row.addprice
      this.editCollectForm.maid = row.apply_id
      this.collectRecord = []
      this.collectRecordDialog = true
      this.collectRecordLoading = true
      materialsCollectRecord({ maid: row.apply_id }).then(response => {
        this.collectRecord = response.data
        this.collectRecordLoading = false
      }).catch(() => {
        this.collectRecordLoading = false
      })
    },
    addCollect() {
      this.editCollectTitle = '添加物料申请单收款'
      this.editCollectForm.crmid = 0
      this.editCollectForm.type = 99
      this.editCollectForm.aid = null
      this.editCollectForm.nature = ''
      this.editCollectForm.money = null
      this.editCollectForm.remark = ''
      this.editCollectForm.card = ''
      this.editCollectForm.receipttime = ''
      this.editCollectForm.paycontent = ''
      this.editCollectForm.imgids = []
      this.editimgList = []
      this.imgLoad = new Date().getTime()
      this.editCollectForm.audittime = ''
      this.editCollectForm.auditname = ''
      this.editCollectForm.rson = ''
      this.editCollectVisible = true
    },
    editCollect(row) {
      this.editCollectTitle = '编辑物料申请单收款'
      this.editCollectVisible = true
      this.editCollectForm.type = 99
      this.editCollectForm.crmid = row.crmid
      this.collectInfoLoading = true
      getCollectRecordMaterialsByCrmid({ crmid: row.crmid }).then(response => {
        this.editCollectForm.aid = response.data.aid
        this.editCollectForm.nature = response.data.nature
        this.editCollectForm.money = response.data.money
        this.editCollectForm.remark = response.data.remark
        this.editCollectForm.card = response.data.card
        this.editCollectForm.receipttime = response.data.receipttime
        this.editCollectForm.paycontent = response.data.paycontent
        this.editCollectForm.audittime = response.data.audittime
        this.editCollectForm.auditname = response.data.auditname
        this.editCollectForm.rson = response.data.rson
        const oldimgList = []
        for (const img of response.data.imglst) {
          oldimgList.push({ id: img.img_id, url: img.img_url })
        }
        this.editimgList = oldimgList
        this.imgLoad = new Date().getTime()
        this.collectInfoLoading = false
      }).catch(() => {
        this.collectInfoLoading = false
      })
    },
    subCollectEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editCollectloading) {
            if (this.editCollectForm.money === null || this.editCollectForm.money === '' || this.editCollectForm.money === undefined) {
              this.editCollectForm.money = 0
            }
            if (parseFloat(this.editCollectForm.money) <= 0) {
              this.$message.error('收款金额不可为0')
              return false
            }
            this.editCollectloading = true
            const data = {
              userid: this.user.userid,
              usertype: 0,
              crmid: this.editCollectForm.crmid,
              maid: this.editCollectForm.maid,
              type: this.editCollectForm.type,
              aid: this.editCollectForm.aid,
              receipttime: this.editCollectForm.receipttime,
              money: this.editCollectForm.money,
              card: this.editCollectForm.card,
              remark: this.editCollectForm.remark,
              nature: this.editCollectForm.nature,
              paycontent: this.editCollectForm.paycontent,
              imgStr: this.editCollectForm.imgids.join(',')
            }
            editMaterialCollectRecord(data).then(response => {
              if (this.editCollectForm.crmid === 0) {
                this.$message({
                  message: '收款添加成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: '收款编辑成功',
                  type: 'success'
                })
              }
              this.editCollectloading = false
              this.editCollectVisible = false
              this.collectRecord = []
              this.collectRecordLoading = true
              materialsCollectRecord({ maid: this.editCollectForm.maid }).then(response => {
                this.collectRecord = response.data
                this.collectRecordLoading = false
              }).catch(() => {
                this.collectRecordLoading = false
              })
            }).catch(() => {
              this.editCollectloading = false
            })
          }
        } else {
          return false
        }
      })
    },
    delCollect(row) {
      this.$confirm('删除此物料申请单收款, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        delMaterialCollectRecord({ crmid: row.crmid }).then(response => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fullscreenLoading = false
          this.collectRecord = []
          this.collectRecordLoading = true
          materialsCollectRecord({ maid: this.editCollectForm.maid }).then(response => {
            this.collectRecord = response.data
            this.collectRecordLoading = false
          }).catch(() => {
            this.collectRecordLoading = false
          })
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    viewCollect(row) {
      this.viewCollectVisible = true
      this.viewCollectLoading = true
      getCollectRecordMaterialsByCrmid({ crmid: row.crmid }).then(response => {
        this.viewCollectData = response.data
        const oldimgList = []
        for (const img of response.data.imglst) {
          oldimgList.push(img.img_url)
        }
        this.viewCollectImg = oldimgList
        this.viewCollectLoading = false
      }).catch(() => {
        this.viewCollectLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delwlsq-container {
  .el-table .el-table__footer-wrapper{
    color:#409EFF;
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
